/**
 * Which pages of the Orders packet carry the INCOMPLETE ORDER label and watermark (PROD-1452), page scope by page
 * scope, as the print-lock rule marks them (`printPreliminary`, Oct 15: "apply watermark only on pages with content
 * which may change"):
 *
 *   - a stop's summary, while THAT school can still change its order;
 *   - a day's pages (the day cover, the shopping list, production totals, the milk page, the recipes and the
 *     pull & pack list), while any school on the day can;
 *   - the shopping list of a multi-day print, while any school in the packet can.
 *
 * Pure; unit-tested.
 */

import { campusBlockId, type PrintPreliminary } from '@/lib/chefs/print-plan'

import type { PacketSection } from './units'

/** The lock label a section's pages print, or null when its counts are final. */
export function sectionLocksAtLabel(
  section: Pick<PacketSection, 'kind' | 'dayIso' | 'campusId'>,
  preliminary: PrintPreliminary | null | undefined,
): string | null {
  if (!preliminary) {
    return null
  }
  if (section.dayIso === null) {
    return preliminary.locksAtLabel
  }
  if (section.kind === 'stop-summary' && section.campusId) {
    return preliminary.campusLocksAtLabel[campusBlockId(section.dayIso, section.campusId)] ?? null
  }
  return preliminary.dayLocksAtLabel[section.dayIso] ?? null
}
